import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { BasicResponse } from "../models/basic-response.model";
import { removeFromLocal, getBasicError, getConnection, getCurrentUser, getErrorMessage, getFromLocal, setOnLocal, getApiKey } from "./functions.service";
import { RequestsService } from "./requests.service";

@Injectable({
    providedIn: 'root',
})
export class MenuService {

    constructor(
        private requestsService: RequestsService,
    ) { }
    /**
     * Consulta los módulos a los que tiene acceso el usuario en esta sesión.
     * @returns Los módulos 
     */
    public getModules(): ModuloMenu[] {
        let result = getFromLocal(environment.LOCAL_MODULES) as ModuloMenu[]
        return result ? result : [];
    }

    /**
     * Guarda los módulos a los que tiene acceso el usuario en localStorage
     * @param modules módulos a guardar
     */
    public setModules(modules: ModuloMenu[]) {
        setOnLocal(environment.LOCAL_MODULES, modules)
    }

    public getRecentModules(): ModuloMenu[] {
        const result = getFromLocal(environment.LOCAL_RECENT_MODULES);
        return result ? result : [];
    }

    public addRecentModule(item: ModuloMenu) {
        const result = this.getRecentModules();
        const find = result.find((element: ModuloMenu) => { return element.descripcion_modulo == item.descripcion_modulo })
        if (!find) {
            result.push(item)
            setOnLocal(environment.LOCAL_RECENT_MODULES, result)
        }
    }

    public deleteRecentModules() {
        removeFromLocal(environment.LOCAL_RECENT_MODULES);
    }

    public deleteModules() {
        removeFromLocal(environment.LOCAL_MODULES)
        removeFromLocal(environment.LOCAL_MODULE_OPTIONS)
        removeFromLocal(environment.LOCAL_CURRENT_MODULE)
        this.deleteRecentModules()
    }

    public searchModule(name: string) {
        name = name.trim().toUpperCase()
        let all = this.getModules()
        all = all && Array.isArray(all) ? all.filter((value: ModuloMenu) => { return value.descripcion_modulo?.toUpperCase().match(`(${name})`) }) : []
        return all
    }

    public getCurrentModuleOptions(): ModuloMenu {
        const result = getFromLocal(environment.LOCAL_CURRENT_MODULE);
        return result ? result : {};
    }

    public setCurrentModuleOptions(modulo: ModuloMenu) {
        setOnLocal(environment.LOCAL_CURRENT_MODULE, modulo);
    }

    public deleteCurrentModuleOptions() {
        removeFromLocal(environment.LOCAL_CURRENT_MODULE);
    }

    public addCurrentOptionsToModules(codigo_modulo: string, options: OpcionMenu[]): ModuloMenu | null {
        let modules = this.getModules()
        for (const key in modules) {
            if (Object.prototype.hasOwnProperty.call(modules, key)) {
                const element = modules[key];
                if (element.codigo_modulo == codigo_modulo) {
                    modules[key].opciones = options
                    this.setModules(modules)
                    return modules[key]
                }
            }
        }
        return null
    }

    public async getOptionsByModule(codigo_modulo: string): Promise<OpcionMenu[]> {
        let options: OpcionMenu[] = []
        let modules = this.getModules()
        //Evaluamos si ya tenemos la ruta guardada
        if (modules.length > 0) {
            for (const key in modules) {
                if (Object.prototype.hasOwnProperty.call(modules, key)) {
                    const element = modules[key];
                    if (element.codigo_modulo == codigo_modulo) {
                        options = element.opciones ? element.opciones : []
                    }
                }
            }
        }
        if (options.length == 0) {
            const result = await this.requestModuleOptions(codigo_modulo)
            if (result.success) {
                const resultOptions = result.data
                if (resultOptions.length) {
                    this.addCurrentOptionsToModules(codigo_modulo, resultOptions)
                    this.setCurrentModuleOptions(resultOptions)
                    options = resultOptions;
                }
            }
        }
        return options
    }

    async requestModules(): Promise<BasicResponse> {
        try {
            const username = getCurrentUser().usuario_aplicativo
            const modulosParams = {
                api_key: getApiKey(),
                username,
                status: "A",
                version: environment.version,
            }
            const modulosResponse = await this.requestsService.makeRequest(environment.domainBasics.replace("{{c_emp}}", getConnection()), environment.urls.auth.modules, modulosParams)
            if (modulosResponse.success) {
                let modules = modulosResponse.data as ModuloMenu[]
                if (Array.isArray(modules) && modules.length) {
                    this.setModules(modules)
                }
            }
            return modulosResponse;
        } catch (error) {
            return new BasicResponse(false, getErrorMessage(error), getBasicError(error))
        }
    }

    async requestModuleOptions(module: string): Promise<any> {
        const optionsParams = {
            api_key: getApiKey(),
            username: getCurrentUser().usuario_aplicativo,
            status: "A",
            module,
            version: environment.version,
        }
        const result = await this.requestsService.makeRequest(environment.domainBasics.replace("{{c_emp}}", getConnection()), environment.urls.auth.moduleOptions, optionsParams)

        return result;
    }
}


export interface ModuloMenu {
    codigo_modulo?: string
    descripcion_modulo?: string
    imagen_url?: string
    descripcion_larga?: string
    url_default?: string
    opciones?: OpcionMenu[]
}
export class OpcionMenu {
    codigo_opcion?: string
    descripcion_opcion?: string
    funcionalidad_general?: string
    icono?: string
    ruta?: string
    rutas?: OpcionMenu[]
}